import useTheme from '@material-ui/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const useIsCollapsibleSidebar = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: false,
    noSsr: true,
  })
}

export default useIsCollapsibleSidebar
